 {
    "common": {
    "thisWeek": "Denne uken",
    "lastWeek": "Forrige uke",
    "lastNumberOfDays": "Siste {numberOfDays} dager",
    "thisMonth": "Denne måneden"
    },
    "subAccounts": "Underkontoer",
    "submitFeedback": "Send inn tilbakemelding",
    "createSubAccount": "Opprett underkonto",
    "viewScheduleReports": "Se planlagte rapporter",
    "searchSubAccount": "Søk etter underkonto",
    "columns": "Kolonner",
    "sortBy": "Sorter etter",
    "selectColumns": "Velge kolonner",
    "maxColumns": "Gir åtte kolonner på en Dato",
    "applyColumns": "Bruk kolonner",
    "activeUsers": "Aktive brukere",
    "appointments": "Avtaler",
    "contacts": "Kontakter",
    "emails": "Gmail",
    "textMessages": "Hoveddel-meldinger",
    "calls": "Anrop",
    "submissions": "Innsendinger",
    "reviews": "Vurderinger",
    "sitesCreated": "Opprettede sider",
    "name": "Navn",
    "formSubmissions": "Skjemainnsendinger",
    "surveySubmissions": "Innsendinger av undersøkelser",
    "facebookFormSubmissions": "Innsendinger av Facebook-skjema",
    "funnels": "Trakter",
    "websites": "Nettsteder",
    "forms": "Skjemaer",
    "surveys": "Undersøkelser",
    "highestFirst": "Maks først",
    "lowestFirst": "Laveste først",
    "orderBy": "Sortere Via",
    "noMoreLocations": "Ikke flere adresse funnet",
    "preparingReport": "Vi forbereder rapporten din …",
    "preparingReportDesc": "Ikke lukk eller last inn dette vinduet på nytt mens eksporten pågår.",
    "outOf": "Fra",
    "subAccountsExported": "Underkontoer eksportert",
    "close": "Lukk",
    "scheduledForDeletion": "Planlagt sletting",
    "readyToSell": "Klar til å selges",
    "closedWon": "Lukket (vunnet)",
    "wpSaleSuccessful": "WordPress-salget er vellykket",
    "wpNotSold": "WordPress ikke solgt ennå",
    "yxtSaleSuccessful": "Yext-salget er vellykket",
    "yxtNotSold": "Den neste er ikke solgt ennå",
    "saasSubInactive": "SaaS avslutningen er inaktiv",
    "saasSubTrialing": "SaaS Abonnement er på prøveperiode",
    "saasSubActive": "SaaS avslutningen er dynamisk",
    "emailRebillingActive": "E-post Omfakturering er dynamisk",
    "emailRebillingInactive": "E-post Omfakturering er Inaktiv",
    "twilioRebillingActive": "Twilio Omfakturering er Dynamisk",
    "twilioRebillingInactive": "Twilio Omfakturering er Inaktiv",
    "wpRebillingActive": "WhatsApp-omfakturering er aktiv",
    "wpRebillingInactive": "WhatsApp-omfakturering er inaktiv",
    "saasModeActivated": "SaaS -modus er Aktivert",
    "paymentPending": "Betaling er under behandling",
    "saasModeNotActivated": "SaaS modus er ikke Aktivert",
    "managedByLCPhone": "Administrer Via LC Telefon",
    "migrationToLCPhone": "Under migrering til LC Telefon",
    "notManagedByLCPhone": "Ikke administrator Via LC Telefon",
    "managedByLCEmail": "Administrer Via LeadConnector Email System",
    "notMangedByLCEmail": "Ikke administrator Via LeadConnector Email System",
    "remainingWalletBalance": "Gjenværende lommeboksaldo for dette SaaS-stedet",
    "reports": "Rapporter",
    "switchToSubAccount": "Bytt til underkonto",
    "manageClient": "Administrer kunde",
    "subAccountDeletedIfChangedMind": "Denne underkontoen vil bli slettet kl. {time}, hvis du har ombestemt deg",
    "subAccountDeletedInMinute": "Denne underkontoen vil bli slettet innen ett minutt",
    "changedMind": "Hvis Du've Dynamisk your mind",
    "clickHere": "klikk henne",
    "subAccountPaused": "Denne underkontoen er satt på pause. Kundene dine kan ikke logge inn, men byrået kan. For å gjenoppta denne kontoen",
    "subAccountRestricted": "Denne underkontoen er satt på pause på grunn av ventende godkjenning.",
    "subAccountVerificationPending": "Denne underkontoen er satt på pause på grunn av ventende e-post- og telefonverifisering fra underkontoadministrator.",
    "subAccountDeclined": "Denne underkontoen er satt på pause på grunn av en avvist godkjenningsforespørsel. Du kan fortsatt gjenoppta denne underkontoen fra ",
    "here": "her.",
    "reviewAndResume": "for å vurdere og gjenoppta denne underkontoen.",
    "incomingCalls": "Innkommende anrop",
    "outgoingCalls": "Utgående anrop",
    "totalTalktime": "Total taletid",
    "incomingEmails": "Innkommende Gmail",
    "outgoingEmails": "Utgående Gmail",
    "incomingSms": "Innkommende Hoveddel-meldinger",
    "outgoingSms": "Utgående Hoveddel-meldinger",
    "contactsCreated": "Totalt antall kontakter opprettet",
    "appointmentsBooked": "Totalt antall bestilte avtaler",
    "totalFormSubmissions": "Total Skjema-innleveringer",
    "totalSurveySubmissions": "Total Spørreundersøkelsesinnsendinger",
    "totalFacebookFormSubmissions": "Total Facebook-skjema-innsendinger",
    "incomingGMBMessages": "Innkommende GBP-meldinger",
    "outgoingGMBMessages": "Utgående GBP-meldinger",
    "gmbMessages": "GBP-meldinger",
    "fbMessages": "Facebook-meldinger",
    "incomingFbMessages": "Innkommende Facebook-meldinger",
    "outgoingFbMessages": "Utgående Facebook-meldinger",
    "igMessages": "Instagram-meldinger",
    "incomingIgMessages": "Innkommende Instagram-meldinger",
    "outgoingIgMessages": "Utgående Instagram-meldinger",
    "totalReviews": "Total antall anmeldelser",
    "positiveReviews": "Positive anmeldelser",
    "negativeReviews": "Negative anmeldelser",
    "back": "Tilbake",
    "selectDashboards": "Velge dashbord",
    "next": "Neste",
    "backToSubAccounts": "Tilbake til underkontoer",
    "pauseSchedule": "Sett plan på Pause",
    "resumeSchedule": "Gjenoppta plan",
    "editSchedule": "Rediger plan",
    "addSchedule": "Legg til plan",
    "selectReportToAdd": "Velge rapporterer til Inkludere in e-posten",
    "selectAll": "Velge hver eneste",
    "pauseScheduleConfirm": "Er du sikker på at du vil sette rapportplanen på Pause ?",
    "resumeScheduleConfirm": "Er du sikker på at du vil Gjenoppta rapportere planen?",
    "tasks": "Oppgaver",
    "conversations": "Samtaler",
    "users": "Bruker",
    "dealOverview": "Oversikt over Avtale",
    "confirmAction": "Bekreft handling",
    "yes": "Ja",
    "no": "Nei",
    "reportDetails": "Rapportdetaljer",
    "reportCreatedOn": "Rapporter Opprettet På",
    "searchByEmail": "Søke Via E-post",
    "lastActivity": "Siste aktivitet",
    "noRecords": "Ingen oppføringer finnes",
    "scheduleReport": "Planlegg rapport",
    "schedule": "plan",
    "save": "Lagre",
    "emailSubject": "Emnelinje",
    "frequency": "Hyppighet",
    "daily": "Daglig",
    "weekly": "Ukentlig",
    "monthly": "Månedlig",
    "nextScheduleDate": "Neste plan Dato",
    "startingOn": "Starter på",
    "timeOfDay": "Dato av Dag",
    "reportsToTimezone": "Rapporten vil bli sendt i underkontoens tidssone",
    "selectRecipients": "Velge mottakere",
    "invalidEmail": "Skriv inn en gyldig e-postadresse.",
    "testEmail": "Test e-post",
    "selectTestRecipients": "Velge Test",
    "setupSubject": "Konfigurer temaet ovenfor for å Test rapporten",
    "sendTest": "Siste opp- Test",
    "scheduleSimilarSchedules": "Planlegg lignende rapport for andre underkontoer",
    "accountSummary": "Kontosammendrag",
    "scheduleList": "Tidsplanliste",
    "subAccountName": "Underkontonavn",
    "nextRunDate": "Neste kjøredato",
    "reportSectionsAdded": "Rapportdeler lagt til",
    "status": "Status",
    "scheduleAction": "Planlegg handlinger",
    "cancel": "Kanseller",
    "pleaseWait": "Laster inn …",
    "confirm": "Bekreft",
    "booked": "Bestilt",
    "confirmed": "Bekreftet",
    "showed": "Møtte opp",
    "noShow": "Møtte ikke opp",
    "cancelled": "Kansellert",
    "unread": "Ulest",
    "engagement": "Engasjement",
    "reaction": "Reaksjon",
    "deliverySummary": "Leveringssammendrag",
    "successfulDelivery": "Vellykket leveranse",
    "opened": "Åpnet",
    "clicked": "Klikket på",
    "replied": "Besvarte",
    "unsubscribed": "Slutt å abonner",
    "complained": "Klaget",
    "failed": "Mislyktes",
    "bounced": "Avviste",
    "open": "Åpne",
    "won": "Vunnet",
    "abandoned": "Forlatt",
    "lost": "Tapt",
    "sent": "Sendt",
    "eject": "Løs ut",
    "delivered": "Sendt",
    "faceBookLeadForm": "Facebook-skjema for potensielle kunder",
    "overdue": "Forsinket",
    "reviewsReceived": "Vurderinger Mottatt",
    "formBuilders": "Skjemabyggere",
    "switchToSaaS": "Bytt til SaaS",
    "numberOfContacts": "Totalt antall kontakter",
    "numberOfAppointments": "Totalt antall avtaler",
    "outreach": "Oppsøkende virksomhet",
    "notSubAccountUser": "Ikke en underkonto-bruker",
    "searchSubAccName": "Søk etter underkontoens navn",
    "recipients": "Mottakere",
    "scheduleCreated": "Tidsplan for e-postrapport er laget for ",
    "scheduleUpdated": "Tidsplan for e-postrapport er oppdatert for ",
    "scheduleNotCreated": "Tidsplan for e-postrapport kunne ikke opprettes for",
    "scheduleNotUpdated": "Tidsplan for e-postrapport kunne ikke oppdateres for",
    "total": "Total",
    "inbound": "Innkommende",
    "outbound": "Utgående",
    "totalEmails": "Totalt antall e-poster",
    "inboundEmails": "Innkommende e-poster",
    "outboundEmails": "Utgående e-poster",
    "totalTextMessages": "Totalt antall tekstmeldinger",
    "inboundTextMessages": "Innkommende tekstmeldinger",
    "outboundTextMessages": "Utgående tekstmeldinger",
    "totalCalls": "Totalt antall anrop",
    "inboundCalls": "Innkommende anrop",
    "outboundCalls": "Utgående anrop",
    "faceBookLeadFormSubmissions": "Innsendinger fra Facebook-leadsjemaer",
    "inboundGMBMessages": "Innkommende GBP-meldinger",
    "outboundGMBMessages": "Utgående GBP-meldinger",
    "totalIgMessages": "Totalt antall Instagram-meldinger",
    "inboundIgMessages": "Innkommende Instagram-meldinger",
    "outboundIgMessages": "Utgående Instagram-meldinger",
    "totalfbMessages": "Totalt antall Facebook-meldinger",
    "inboundfbMessages": "Innkommende Facebook-meldinger",
    "outboundfbMessages": "Utgående Facebook-meldinger",
    "sitesCreatedFunnels": "Opprettede sider – trakter",
    "sitesCreatedActiveFunnels": "Opprettede sider – aktive trakter",
    "sitesCreatedWebsites": "Opprettede sider – nettsteder",
    "sitesCreatedActiveWebsites": "Opprettede sider – aktive nettsteder",
    "sitesCreatedForms": "Opprettede sider – skjemaer",
    "sitesCreatedActiveForms": "Opprettede sider – aktive skjemaer",
    "sitesCreatedSurveys": "Opprettede sider – undersøkelser",
    "sitesCreatedActiveSurveys": "Opprettede sider – aktive undersøkelser",
    "googleReviews": "Google-anmeldelser",
    "facebookReviews": "Facebook-anmeldelser",
    "inboundCallDuration": "Innkommende samtalevarighet (timer)",
    "outboundCallDuration": "Utgående samtalevarighet (timer)",
    "pleaseSelect": "Velg",
    "subAccountIsDeleted": "Denne underkontoen har blitt slettet",
    "subAccountIsPaused": "Denne underkontoen har blitt satt på pause",
    "success": "Vellykket",
    "error": "Feil",
    "testEmailSent": "Test e-post sendt",
    "testEmailNotSent": "Test e-posten kunne ikke sendes",
    "reviewRequest": "Vurderingsforespørsel",
    "pendingTransferDescription": "Andre byråer har bedt om å overføre underkontoer til deg.",
    "pendingTransferHeading": "Du har ventende forespørsler om overføring av underkonto.",
    "subAccountTransfer": "Overføringer av underkontoer",
    "manageSubAccTransfer": "Administrer forespørsler om overføring av underkontoer",
    "subAccRequest": "Forespørsler for underkontoen {tabName}",
    "receive": "Arve",
    "send": "Send",
    "release": "Versjon",
    "requests": "{count} forespørsler",
    "subAccLimit": "Bruksgrensen for underkontoer er nådd.",
    "subAccPlanLimit": "Du har brukt tre av tre underkontoer som er tilgjengelige i den nåværende planen din.",
    "upgradeTime": "Det er på tide å oppgradere!",
    "upgradeHigher": "Oppgrader til et høyere abonnement for å godta overføringen av underkontoen.",
    "browse": "Bla gjennom planer",
    "pendingTransferTitle": "En overføringsforespørsel for denne underkontoen venter allerede.",
    "unableTransfer": "Kan ikke laste opp underkonto til dette byrået.",
    "unableEjectCancel": "Kan ikke avbryte forespørselen om utløsing av underkonto.",
    "EjectErrorDetails": "Forespørselen om å utløse underkontoen kan ikke kanselleres.",
    "hippaErrorDescription": "Denne underkontoen er HIPAA-aktivert og kan ikke overføres til et ikke-HIPAA-byrå.",
    "pendingTransferErrorDescription": "Kanseller den eksisterende overføringsforespørselen for denne underkontoen før du oppretter en ny.",
    "receivingAgency": "Mottakende byrå",
    "releasingAgency": "Frigivende byrå",
    "noOfContacts": "Totalt antall kontakter",
    "requestedDate": "Ønsket dato",
    "action": "Handling",
    "cancelTransfer": "Kanseller overføring",
    "decline": "Avvise",
    "cancelTransferRequest": "Vil du kansellere forespørselen om overføring av underkonto?",
    "cancelEjectRequest": "Kansellere forespørselen om å løse ut underkontoen?",
    "cancelRequestDescription": "Mottakerbyrået vil ikke lenger se denne overføringsforespørselen og underkontoen {name} vil ikke bli overført.",
    "cancelEjectRequestDescription": "Den valgte brukeren vil ikke lenger kunne opprette et nytt byrå fra underkontoen {name}.",
    "declineRequest": "Avvise forespørselen om overføring av underkontoen?",
    "declineRequestDescription": "Forespørselen vil bli avslått og underkontoen {name} vil ikke bli overført til byrået ditt.",
    "approveTransfer": "Godkjenne overføringen av underkontoen til byrået ditt?",
    "approveTransferDescription": "Underkontoen {name} vil bli overført til byrået ditt.",
    "transferNow": "Overfør nå",
    "cancelNow": "Kanseller nå",
    "transferErrorDetails": "Denne underkontoen kan ikke overføres.",
    "cancelRequest": "Avbryt forespørsel",
    "received": "Mottatt",
    "approve": "Godkjenne",
    "goBack": "Gå tilbake",
    "done": "Ferdig",
    "subAccountTransferred": "Underkontoen har blitt overført!",
    "subAccountTransferDescription": "Selv om underkontoen er overført, kan det fortsatt ta 10–15 minutter før enkelte elementer som brukere, telefonnumre, Mailgun-kontoer og Yext-oppføringer vises i destinasjonen.",
    "activeSubscriptionsAlert": "Stedet har Dynamisk Abonnement. Please Kansellere hver eneste Abonnement Før Blind overføring the Sted. Liste av Dynamisk Abonnement: {subscriptions}",
    "isSaasEnabled": "SaaS er aktivert",
    "typeToSearch": "Skriv inn for å søke",
    "dateAdded": "Dato lagt til",
    "emailEngagement": "E-postengasjement",
    "emailReaction": "E-postreaksjon",
    "emailDeliverySummary": "Sammendrag av e-postlevering",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Kontosammendrag – {subAccountName}",
    "test": "Test",
    "scheduleExists": "Plan eksisterer",
    "aToZ": "A–Å",
    "zToA": "Å – A",
    "onlyAdminUsersCanAddNewSubAccounts": "Kun administratorer kan legge til nye underkontoer.",
    "locationName": "Stedsnavn",
    "transferCompleted": "Overføringsforespørsel for dette stedet er allerede behandlet. Oppdater siden.",
    "unauthorizedTransfer": "Du er ikke autorisert til å utføre denne håndteringen. Kun Byrå-eiere kan utføre denne håndteringen.",
    "bulkLocationTransfer": "Bulkoverfør underkontoer",
    "singleRequest": "Enkeltforespørsel",
    "bulkRequest": "Bulk-forespørsel",
    "backToLocationTransfer": "Tilbake til overføring av sted",
    "initiateBulkTransfer": "Start bulkoverføring av underkontoer",
    "initiateBulkTransferDescription": "Velg underkontoene du ønsker å overføre eller skriv inn ID-ene deres atskilt med komma.",
    "subAccountId": "Underkonto-ID",
    "selectFromList": "Velg fra listen",
    "addManually": "Legg til manuelt",
    "accountsSelected": "{count} er valgt",
    "selectAllSubAccounts": "Velge hver eneste",
    "removeAll": "Fjern alle",
    "addManualLocations": "Legg til steds-ID-er atskilt med komma",
    "manualAllLocationIds": "Sted ID-er av under-Konto Du ønsker å overføre, separert Via komma.",
    "enterLocationIds": "Angi steds-ID-er",
    "selectSubAccounts": "Velg underkontoer og overfør til et eksisterende byrå",
    "subAccountTransferWarning": "hver eneste underKonto-aktiva og Bruker vil få Laste ned.",
    "proceed": "Fortsette",
    "bulkRequestSubmitted": "Forespørsel om bulkoverføring sendt inn",
    "bulkRequestSubmittedDescription": "Hver underkonto vil bli overført når mottakerbyrået godtar overføringsforespørselen. Du kan spore statusen til forespørselen på \"{pagename}\"-siden. (Forutsatt at de er berettiget)",
    "bulkTransferRequestFailed": "Forespørsel om bulkoverføring mislyktes",
    "errorLocations": "Underkontoer med feil",
    "viewDetails": "Vis detaljer",
    "somethingWrong": "Noe gikk galt. Prøv på nytt.",
    "confirmBulkRequest": "Bekreft forespørsel om bulkoverføring?",
    "bulkTransferAccounts": "Bulkoverføring av \"{count}\" valgte underkontoer?",
    "confirmDetails": "Bekreft detaljene før du overfører.",
    "transferConsent": "Jeg har Lese og forstått veiledningen ovenfor og Tillatelse til hver eneste begrensningene.",
    "transferInfo": "Overføring til underkonto forutsetter at mottakerbyrået godtar overføringen til deres konto.",
    "receivingRelNo": "Mottakerbyråets relasjonsnummer",
    "enterRelNo": "Angi relasjonsnummer",
    "transferConfirmation": "Etter at denne håndteringen er fullført, vil Bulk Overføre Forespørsler bli sendt til Mottatt Byrå ({ relNo }). hver eneste underKonto Du've Valgt vil bli lastet ned når Mottatt Byrå godtar den. Vær oppmerksom på at denne håndteringen er irreversibel for hver eneste underkonto som er inkludert in Overføret.",
    "confirmPassword": "Bekreft Ved å skrive password under",
    "enterPassword": "Skriv inn passord",
    "requestTransfer": "Be om overføring",
    "confirmTransfer": "Bekreft overføring",
    "notNow": "Ikke nå",
    "invalidRelNo": "Ugyldig relasjonsnummer",
    "invalidPassword": "Ugyldig password.",
    "searchSubAccounts": "Søk etter underkontoer",
    "searchSubAccountsId": "Søk etter underkonto-ID",
    "takeAction": "Ta grep",
    "sub_account_details": "Detaljer om underkonto",
    "no_of_contacts": "Totalt antall kontakter",
    "transfer_status": "Overføringsstatus",
    "error_info": "Feilinfo",
    "bulk_transfer_status": "Status for bulkoverføring av underkonto",
    "pending": "I påvente av",
    "processed": "Behandlet",
    "reject_all": "Avvis alle",
    "accept_all": "Godta alle",
    "cancel_all": "Kanseller alle",
    "clearAll": "Fjern alle",
    "refresh": "Oppdater",
    "rejected": "Nektet",
    "decline_transfer": "Avslå overføring",
    "decline_bulk_transfer": "Avslå forespørsel om bulkoverføring av underkontoer?",
    "decline_bulk_transfer_description": "Forespørselen vil bli avslått, og {length} underkontoene vil ikke bli overført til byrået ditt.",
    "accept_bulk_transfer": "Godta forespørsel om bulkoverføring av underkontoer?",
    "accept_bulk_transfer_description": "Forespørselen vil bli akseptert, og {length} underkontoene vil bli overført til byrået ditt.",
    "cancel_bulk_transfer": "Kansellere bulkoverføring?",
    "cancel_bulk_transfer_description": "Er du sikker på at du vil kansellere denne bulkoverføringen av {length} underkontoer til \"{name}\"?",
    "consent_sub_account_transfer": "Vennligst Lese og Tillatelse til {link}",
    "sub_account_transfer_guidelines": "Retningslinjer for overføring av underkonto",
    "valid_rel": "Skriv inn gyldig tall",
    "something_went_wrong": "Noe gikk galt. Prøv på nytt.",
    "export": "Eksporter",
    "export_success": "Opplysningene som Du ba om, er under behandling. Du vil sende en e-post med dataene in noen Dato.",
    "export_failed": "Dataene Du ba om kunne ikke behandles. Vennligst prøv igjen senere.",
    "selectAllError": "Du kan kun velge 1 000 underkontoer om gangen.",
    "max1000": "(Maks. 1 000)",
    "subAccountCount": "Antall underkontoer",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Er du sikker på at du vil sette {count} rapporter på Pause ?",
    "scheduleBulkResumeConfirm": "Er du sikker på at du vil Gjenoppta {count} -rapporter?",
    "resume": "Gjenoppta",
    "pause": "Pause",
    "resumeSelected": "Gjenoppta Valgt",
    "pauseSelected": "Pause Valgt",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} rapporter valgt",
    "selectAllXReports": "Velg alle {count} -rapporter",
    "scheduleStatus": "Tidsplanstatus",
    "scheduleSearchPlaceholder": "Søk ved hjelp av e-post eller sted navn",
    "subAccountsPerPage": "Underkontoer per side",
    "previous": "Forrige",
    "scheduleBulkAction": "Planlegg bulk-handling",
    "all": "Alle",
    "active": "Aktiv",
    "paused": "Satt på pause",
    "scheduleUpdatedSuccessfully": "planlegge Oppdatert vellykket",
    "saveChanges": "Lagre endringer",
    "pauseSchedulesTitle": "Pause Aktiv Planlagt rapporterer",
    "pauseSchedulesDescription": "Klikk for å sette på Pause nå Aktiv-rapporter.",
    "pauseSchedulesAlert": "Dette vil kun påvirke kontoer som er nå Dynamisk.",
    "pauseAllSchedulesBtnText": "Sett alle planlagte rapporter på pause",
    "autoScheduleTitle": "Automatisk planlegging for nye kontoer",
    "autoScheduleLabel": "Opprett automatisk planlagte rapporter når en ny underkonto blir lagt til.",
    "autoScheduleAlert": "Deaktiver denne Hvis Du ønsker å konfigurere for ny Konto manuelt.",
    "autoScheduleEnabledForNewAccounts": "Auto-Planlegge Aktivert for ny Konto",
    "autoScheduleDisabledForNewAccounts": "Auto-Planlegge Deaktivert for ny Konto",
    "deleted": "Slettet",
    "locationPaused": "Sted satt på pause",
    "scheduleSettingsModalTitle": "planrapport Innstillinger",
    "selectAllSchedules": "Velge hver eneste Planlegge",
    "selectScheduleForLocation": "Velge plan for {location}",
    "openSettings": "Åpne Innstillinger",
    "resumeScheduleForLocation": "Gjenoppta plan for {location}",
    "pauseScheduleForLocation": "Sett plan på Pause for {location}",
    "actions": "Handlinger",
    "deselectAll": "Fjern markeringen av hver eneste",
    "scheduleBulkActionResumeSuccess": "Bulk -aktivering in — På hold Deaktivert På nye aktiviteter",
    "scheduleBulkActionPauseSuccess": "Setter rapporter på pause – vent før du utfører flere handlinger",
    "bulkActionCreationError": "En annen bulkhandling pågår. Prøv på nytt om et øyeblikk.",
    "bulkActionInProgress": "Bulk -håndtering in allerede",
    "scheduledReports": "Planlagt rapporter",
    "scheduleBulkActionCompleted": "Bulk Ferdig vellykket",
    "pauseAllSchedulesModalTitle": "Sette rapporter på pause?",
    "pauseAllSchedulesModalText": "Dette vil sette alle aktive planlagte rapporter på pause på tvers av underkontoer.",
    "addLocationIdsPlaceholder": "Legg til steds-ID-er du vil overføre ...",
    "helloWorld": {
      "count": "Antall er {count}",
      "editIntro": "Rediger",
      "editAction": "For å teste HMR",
      "checkOut": "Sjekk",
      "officialStarter": ", den offisielle Vue + Vite-startpakken",
      "install": "Installer",
      "installDescription": "I din IDE for en bedre DX",
      "learnMore": "Klikk på Vite- og Vue-logoene for å lære mer"
    },
    "home": {
      "testMessage": "Hei! Dette er test-hjemmesiden!"
    },
    "reports": {
      "incoming": "Innkommende",
      "outgoing": "Utgående",
      "duration": "Varighet",
      "contactsCount": "Totalt antall kontakter",
      "appointmentsCount": "Totalt antall avtaler",
      "formSubmissions": "Skjemainnsendinger",
      "surveySubmissions": "Innsendinger av undersøkelser",
      "facebookFormSubmissions": "Innsendinger av Facebook-skjema",
      "funnels": "Trakter",
      "websites": "Nettsteder",
      "forms": "Skjemaer",
      "surveys": "Undersøkelser",
      "gbpMessages": "GBP-meldinger",
      "facebookMessages": "Facebook-meldinger",
      "instagramMessages": "Instagram-meldinger",
      "reviews": "Vurderinger",
      "positives": "Positive",
      "negatives": "Negative"
    },
    "timeOptions": {
      "00": "kl. 00.00",
      "01": "kl. 01.00",
      "02": "kl. 02.00",
      "03": "kl. 03.00",
      "04": "kl. 04.00",
      "05": "kl. 05.00",
      "06": "kl. 06.00",
      "07": "kl. 07.00",
      "08": "kl. 08.00",
      "09": "kl. 09.00",
      "10": "kl. 10.00",
      "11": "kl. 11.00",
      "12": "kl. 12.00",
      "13": "kl. 13.00",
      "14": "kl. 14.00",
      "15": "kl. 15.00",
      "16": "kl. 16.00",
      "17": "kl. 17.00",
      "18": "kl. 18.00",
      "19": "kl. 19.00",
      "20": "kl. 20.00",
      "21": "kl. 21.00",
      "22": "kl. 22.00",
      "23": "kl. 23.00"
    },
    "transferStatus": {
      "pending": "Avventer",
      "processed": "Behandlet",
      "canceled": "Avlyst",
      "cancelled": "Avlyst",
      "completed": "Fullført",
      "rejected": "Avvist",
      "failed": "Mislyktes",
      "payment_pending": "Betaling venter"
    }
    }
